module.exports = __webpack_public_path__ + "img/gif-loader.cea919e1.gif";